export const serverErrorDetail = (error: unknown) => [error ?? []].flat().join(", ") || null;
